import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { ClienteFiscalPerfil } from '@/features/cliente/types/enum';
import { DestinoNotaFiscal } from '@/features/fiscal/enum/DestinoNotaFiscal';
import { DevolucaoOperacao } from '@/features/fiscal/enum/DevolucaoOperacao';
import { TipoCliente } from '@/features/fiscal/enum/TipoCliente';
import { NotaFiscalTipo } from '@/features/nfe/types/enum';

enum RegraFiscalIcmsModalidade {
    MargemValorAgregado = 0,
    Pauta = 1,
    PrecoTabelaMaxima = 2,
    ValorOperacao = 3,
}

enum RegraFiscalIcmsSTModalidade {
    PrecoTabeladoMaximoSugerido = 0,
    ListaNegativa = 1,
    ListaPositiva = 2,
    ListaNeutra = 3,
    MargemValorAgregado = 4,
    Pauta = 5,
    ValorOperacao = 6,
}

export const RegraFiscalIcmsSchema = z.object({
    ric_calcular_icmsstret: z.enum(['S', 'N']),
    ric_cbenef: z.string().nullable(),
    ric_cfop_codigo: z.number().nullable(),
    ric_csosn: z.string().nullable(),
    ric_cst: z.string().nullable(),
    ric_destino: z.enum(DestinoNotaFiscal),
    ric_devolucao_operacao: z.enum(DevolucaoOperacao).nullable(),
    ric_difal_dest_uf_percentual: z.number().nullable(),
    ric_empresa_idpk: z.number(),
    ric_estado_especifico: z.string().nullable(),
    ric_fcp_aliquota: z.number(),
    ric_fcp_gerar: z.enum(['S', 'N']).nullable(),
    ric_fcpst_aliquota: z.number(),
    ric_fcpst_gerar: z.enum(['S', 'N']).nullable(),
    ric_gerar_credito_icms: z.enum(['S', 'N']),
    ric_icms_diferido_percentual: z.number(),
    ric_icms_fiscal_tabela_preco_idpk: z.number().nullable(),
    ric_icms_modalidade: z.enum(RegraFiscalIcmsModalidade).nullable(),
    ric_icms_percentual: z.number().nullable(),
    ric_icms_reducao_bc: z.number().nullable(),
    ric_icmsst_fiscal_tabela_preco_idpk: z.number().nullable(),
    ric_icmsst_modalidade: z.enum(RegraFiscalIcmsSTModalidade).nullable(),
    ric_icmsst_percentual: z.number().nullable(),
    ric_icmsst_percentual_mva: z.number().nullable(),
    ric_icmsst_reducao_bc: z.number().nullable(),
    ric_idpk: z.number(),
    ric_motivo: z.number().nullable(),
    ric_perfil_cliente: z.enum(ClienteFiscalPerfil),
    ric_regra_fiscal_idpk: z.number(),
    ric_tipo: z.enum(NotaFiscalTipo),
    ric_tipo_cliente: z.enum(TipoCliente),
    ric_todos_estados: z
        .enum(['S', 'N', ''])
        .nullable()
        .transform((v) => (v === '' ? null : v)),
});

type RegraFiscalIcms = z.infer<typeof RegraFiscalIcmsSchema>;

export type RegraFiscalIcmsBody = PartialUndefinedOrNull<RegraFiscalIcms> & TableEditItem;
